import React, { useState, useContext } from 'react';
import ListItemImage from './ListItemImage';
import Article from './Article';
import { TranslationContext } from "../Context";

function NotFoundListItem(props) {
    const translation = useContext(TranslationContext);
    function handleRemoveItemButtonClick(e){
        
        props.onItemRemove(props.article.articleNumber);
    }

    return (<li className="vehicleProductListComponent-item">
        <div className="vehicleProductListComponent-itemInner">
            <ListItemImage />
            <div className="vehicleProductListComponent-articleInfo">
                <Article articleNumber={props.item.articleNumber} />
                <div className="vehicleProductListComponent-priceContainer">
                    <div className="vehicleProductListComponent-warning alert-danger">{translation["TecAlliencePartSearch.ProductList.ItemList.ItemIsNotAvailable"]}</div>
                    <div className="vehicleProductListComponent-prices">
                        <div className="vehicleProductListComponent-pricesPiece">
                            <div className="vehicleProductListComponent-pricesPiecePrice u-textSemi18"></div>
                            <div className="vehicleProductListComponent-pricesMsrp u-textRegular14"></div>
                        </div>
                        <div className="vehicleProductListComponent-pricesTotal">
                            <div className="u-textSemi24"></div>
                            <div className="vehicleProductListComponent-pricesMsrp u-textRegular14"></div>
                        </div>
                    </div>
                    <div className="vehicleProductListComponent-submit">
                        <button className="vehicleProductListComponent-submitBtn btn btn-default" onClick={handleRemoveItemButtonClick}>{translation["TecAlliencePartSearch.ProductList.ItemList.Remove"]}</button>
                    </div>
                </div>
            </div>
        </div>
    </li>);
}

export default NotFoundListItem;